"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerValidator = exports.useCustomerValidation = void 0;
const React = __importStar(require("react"));
const ValidationContext_1 = require("../../context/ValidationContext");
const validators_1 = require("./validators");
;
const customerValidationRule = (s, fn, msg) => {
    return { [s]: { fn, errMsg: (!!msg ? msg : undefined) } };
};
const useCustomerValidation = (selector, customer) => {
    const validator = customerValidators[selector];
    if (!validator) {
        throw new Error(`No validator for ${selector.toString()}`);
    }
    const validationContext = React.useContext(ValidationContext_1.ValidationContext);
    const [valid, setValid] = React.useState(false);
    React.useEffect(() => {
        let isValid = false;
        if (customer) {
            isValid = validator.fn(customer[selector]);
            if (validationContext.state.customer[selector.toString()] !== isValid) {
                validationContext.dispatch(ValidationContext_1.validationActions.updateCustomer(selector, isValid));
            }
        }
        setValid(isValid);
    }, [customer]);
    return [valid, (valid ? undefined : validator.errMsg)];
};
exports.useCustomerValidation = useCustomerValidation;
const getCustomerValidator = (selector) => {
    return customerValidators[selector];
};
exports.getCustomerValidator = getCustomerValidator;
const customerValidators = Object.assign(Object.assign(Object.assign({}, customerValidationRule('name', validators_1.stringPresent, 'Must provide your name')), customerValidationRule('phone', (val) => !!val && val.length >= 3, 'Must provide your phone number')), customerValidationRule('email', validators_1.validEmail, 'Must provide a valid email address'));
//# sourceMappingURL=customer.js.map